import styled from 'styled-components';

import { theme } from '../ui/theme';

export const PreformattedText = styled.pre`
    font-variant-numeric: lining-nums tabular-nums stacked-fractions slashed-zero;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'DejaVu Sans Mono',
        'Courier New', monospace;
    font-size: 12px;
    font-style: normal;
    font-weight: ${theme.fontWeights[400]};
    line-height: normal;
    background-color: ${theme.colors.background.emphasis};
    color: ${theme.colors.foreground.onEmphasis};
    border: none;
    padding: ${theme.space[12]};
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
`;
